import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n.use(Backend).use(initReactI18next).init({
    lng: localStorage.getItem("lang"), //default language from localStorage.
    fallbackLng: "es", // use de if selected language is not available
});